import { createReducer, on } from '@ngrx/store';

import { IListGames, IRatingByGame, IRatingGeneral, IUserInfoGames } from '../../shared/models/Games.model';
import {
    ClearRatingByGame,
    errorListGames,
    errorRating,
    errorRatingByGame,
    errorSaveGoing,
    errorSendConnection,
    errorSendStatusLifesModal,
    errorStartGame,
    errorStatusLifesModal,
    errorUserInfoGames,
    extrasLives,
    getListGames,
    getRating,
    getRatingByGame,
    getUserInfoGames,
    saveGoing,
    selectGame,
    selectGameReset,
    sendConnection,
    sendStatusLifesModal,
    startGame,
    statusLifesModal,
    successListGames,
    successRating,
    successRatingByGame,
    successSaveGoing,
    successSendConnection,
    successSendStatusLifesModal,
    successStartGame,
    successStatusLifesModal,
    successUserInfoGames,
} from '../actions';


/**
 * Obtiene la lista de juegos
 */
export interface ListGamesState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    ListGames: IListGames[];
}

export const ListGamesInit: ListGamesState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    ListGames: []
};

const _listGamesReducer = createReducer(ListGamesInit,
    on(getListGames, (state) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false,
            ListGames: [],
        }
    )),
    on(successListGames, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            ListGames: data
        }
    )),
    on(errorListGames, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: payload
        }
    )),
);

export function ListGamesReducer(state: any, action: any) {
    return _listGamesReducer(state, action);
}

/**
 * Obtiene la info del usuario
 */
export interface UserInfoGamesState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    UserInfo: IUserInfoGames;
}

export const UserInfoGamesInit: UserInfoGamesState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    UserInfo: {
        Vidas: 0,
        Puntaje: 0,
        Segundos: 0,
        Corcholatas: 0,
        Responsable: ''
    }
};

const _userInfoGamesReducer = createReducer(UserInfoGamesInit,
    on(getUserInfoGames, (state) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false
        }
    )),
    on(successUserInfoGames, (state, resp) => (
        {
            ...state,
            loading: false,
            success: true,
            UserInfo: resp
        }
    )),
    on(errorUserInfoGames, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: payload
        }
    )),
);

export function UserInfoGamesReducer(state: any, action: any) {
    return _userInfoGamesReducer(state, action);
}


/**
 * Obtiene la info del leaderboard general
 */
export interface RatingState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    Leaderboard: IRatingGeneral[];
}

export const RatingInit: RatingState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    Leaderboard: []
};

const _ratingReducer = createReducer(RatingInit,
    on(getRating, (state) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false
        }
    )),
    on(successRating, (state, resp) => (
        {
            ...state,
            loading: false,
            success: true,
            Leaderboard: resp.data
        }
    )),
    on(errorRating, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: payload
        }
    )),
);

export function RatingReducer(state: any, action: any) {
    return _ratingReducer(state, action);
}

/**
 * Obtiene la info del leaderboard por juego
 */
export interface RatingByGameState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    Leaderboard: IRatingByGame;
}

export const RatingByGameInit: RatingByGameState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    Leaderboard: null
};

const _ratingByGameReducer = createReducer(RatingByGameInit,
    on(getRatingByGame, (state) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false
        }
    )),
    on(successRatingByGame, (state, resp) => (
        {
            ...state,
            loading: false,
            success: true,
            Leaderboard: resp.data
        }
    )),
    on(errorRatingByGame, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: payload
        }
    )),
    on(ClearRatingByGame, state => ({ ...state, ...RatingByGameInit })),
);

export function RatingByGameReducer(state: any, action: any) {
    return _ratingByGameReducer(state, action);
}

/**
 * Añade el juego seleccionado
 */
export interface SetSelectGameState extends IListGames {
    ID_Juego: number;
}

export const SetSelectGameInit: SetSelectGameState = {
    ID_Juego: 0,
    Juego: '',
    Imagen: '',
    Estatus: 0
};

const _setSelectGameReducer = createReducer(SetSelectGameInit,
    on(selectGame, (state, juego) => ({ ...state, ...juego })),
    on(selectGameReset, state => ({ ...state, ...SetSelectGameInit })),
);

export function SetSelectGameReducer(state: any, action: any) {
    return _setSelectGameReducer(state, action);
}


/**
 * Guarda la informacion de la partida
 */
export interface SaveGoingState {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
    data: string;
}

export const SaveGoingInit: SaveGoingState = {
    error: null,
    failed: false,
    success: false,
    loading: false,
    data: '',
};

const _saveGoingReducer = createReducer(SaveGoingInit,
    on(saveGoing, (state) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false
        }
    )),
    on(successSaveGoing, (state, resp) => (
        {
            ...state,
            loading: false,
            success: true,
            data: resp.data
        }
    )),
    on(errorSaveGoing, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: payload
        }
    )),
);

export function SaveGoingReducer(state: any, action: any) {
    return _saveGoingReducer(state, action);
}

/**
 * Redime las vidas de la partida
 */

const _startGameReducer = createReducer(SaveGoingInit,
    on(startGame, (state) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false
        }
    )),
    on(successStartGame, (state, resp) => (
        {
            ...state,
            loading: false,
            success: true,
            data: resp.data
        }
    )),
    on(errorStartGame, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: payload
        }
    )),
);

export function StartGameReducer(state: any, action: any) {
    return _startGameReducer(state, action);
}

/**
 * Consulta si es modal de aviso de seccion o modal de recompensa diaria
 */

interface IEffects {
    error: Error | null;
    failed: boolean;
    success: boolean;
    loading: boolean;
}
export interface IGetStatus extends IEffects {
    status: 0 | 1 | 2;
}
interface ISendStatus extends IEffects {
    data: string;
}

export interface StatusLifesState {
    GetStatus: IGetStatus;
    SendStatus: ISendStatus;
}

export const StatusLifesInit: StatusLifesState = {
    GetStatus: {
        error: null,
        failed: false,
        success: false,
        loading: false,
        status: 0,
    },
    SendStatus: {
        error: null,
        failed: false,
        success: false,
        loading: false,
        data: ''
    }
};

const _statusLifesModalReducer = createReducer(StatusLifesInit,
    on(statusLifesModal, (state) => (
        {
            ...state,
            GetStatus: {
                ...state.GetStatus,
                loading: true,
                success: false,
                failed: false
            }
        }
    )),
    on(successStatusLifesModal, (state, { data }) => (
        {
            ...state,
            GetStatus: {
                ...state.GetStatus,
                loading: false,
                success: true,
                status: data.status
            }
        }
    )),
    on(errorStatusLifesModal, (state, { payload }) => (
        {
            ...state,
            GetStatus: {
                ...state.GetStatus,
                loading: false,
                success: false,
                failed: true,
                error: payload
            }
        }
    )),
    on(sendStatusLifesModal, (state, { status }) => (
        {
            ...state,
            SendStatus: {
                ...state.SendStatus,
                loading: true,
                success: false,
                failed: false
            },
            GetStatus: {
                ...state.GetStatus,
                status,
            }
        }
    )),
    on(successSendStatusLifesModal, (state, { data }) => (
        {
            ...state,
            SendStatus: {
                ...state.SendStatus,
                loading: false,
                success: true,
                data
            },
        }
    )),
    on(errorSendStatusLifesModal, (state, { payload }) => (
        {
            ...state,
            SendStatus: {
                ...state.SendStatus,
                loading: false,
                success: false,
                failed: true,
                error: payload
            }
        }
    )),
);

export function StatusLifesModalReducer(state: any, action: any) {
    return _statusLifesModalReducer(state, action);
}

/**
 * Envia el evento de la info de dispositivo por conexion del app
 */

const _statusSendConnectionReducer = createReducer(SaveGoingInit,
    on(sendConnection, (state) => (
        {
            ...state,
            loading: true,
            success: false,
            failed: false
        }
    )),
    on(successSendConnection, (state, { data }) => (
        {
            ...state,
            loading: false,
            success: true,
            data
        }
    )),
    on(errorSendConnection, (state, { payload }) => (
        {
            ...state,
            loading: false,
            success: false,
            failed: true,
            error: payload
        }
    )),
);

export function SendConnectionReducer(state: any, action: any) {
    return _statusSendConnectionReducer(state, action);
}

/**
 * Se agrega vidas extras para popup
 */
export interface ExtrasLivesState {
    VidasGanadas: number;
}

export const ExtrasLivesInit: ExtrasLivesState = {
    VidasGanadas: 0,
};

const _extrasLivesReducer = createReducer(ExtrasLivesInit,
    on(extrasLives, (state, { VidasGanadas }) => (
        {
            ...state,
            VidasGanadas,
        }
    )),
);

export function ExtrasLivesReducer(state: any, action: any) {
    return _extrasLivesReducer(state, action);
}